import React from 'react';
import Products from '../components/Products';

export default function AllProducts() {
  return <Products />;
}
